import React, { useState } from 'react';
import { Check, X, ArrowRight, Layers, Clock, BarChart3, Users, Shield, Briefcase, RefreshCw } from 'lucide-react';
import { motion } from 'framer-motion';
export function SummitProduct() {
  const [isPartialCampaign, setIsPartialCampaign] = useState(false);
  return <div className="min-h-screen w-full bg-[#0A0F1C] text-slate-200 selection:bg-amber-500/30 font-sans" data-id="element-693">
      {/* 1. HERO */}
      <section className="relative pt-32 pb-20 px-6 md:px-12 max-w-7xl mx-auto text-center" data-id="element-694">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-96 bg-amber-500/5 blur-[120px] rounded-full pointer-events-none" data-id="element-695" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-696">
          <div className="inline-block px-3 py-1 rounded-full bg-amber-500/10 border border-amber-500/20 text-amber-400 text-xs font-bold uppercase tracking-widest mb-6" data-id="element-697">
            Embedded Execution
          </div>
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 tracking-tight" data-id="element-698">
            HIRE Summit
          </h1>
          <p className="text-xl md:text-2xl text-slate-400 max-w-3xl mx-auto mb-8 leading-relaxed" data-id="element-699">
            When recruiting execution becomes the constraint, HIRE runs it for
            you.
          </p>
          <p className="text-lg text-slate-500 max-w-2xl mx-auto border-t border-slate-800 pt-8" data-id="element-700">
            Summit is designed for teams who want recruiting execution handled
            so leadership can stay focused on production and growth.
          </p>
        </motion.div>
      </section>

      {/* 2. THE EXECUTION BOTTLENECK */}
      <section className="py-20 px-6 md:px-12 max-w-4xl mx-auto border-t border-slate-800/50" data-id="element-701">
        <div className="text-center mb-12" data-id="element-702">
          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-703">
            The Execution Bottleneck
          </h2>
          <p className="text-slate-400 text-lg" data-id="element-704">
            At scale, recruiting doesn't fail because of traffic or systems.
          </p>
        </div>

        <div className="bg-slate-900/30 border border-slate-800 p-8 md:p-12 rounded-xl" data-id="element-705">
          <h3 className="text-sm text-amber-400 uppercase tracking-widest font-bold mb-6 text-center" data-id="element-706">
            Execution Constraints
          </h3>
          <ul className="space-y-4 max-w-2xl mx-auto" data-id="element-707">
            {['Leaders are pulled into interviews', 'Follow-up slows down', 'Calendars bottleneck', 'Recruiting becomes a second job'].map((item, idx) => <li key={idx} className="flex items-start text-slate-300" data-id="element-708">
                <X className="w-5 h-5 text-amber-500/50 mr-3 mt-0.5 flex-shrink-0" data-id="element-709" />
                <span data-id="element-710">{item}</span>
              </li>)}
          </ul>
          <p className="text-center text-slate-400 mt-8 pt-8 border-t border-slate-800" data-id="element-711">
            Summit exists to remove that bottleneck.
          </p>
        </div>
      </section>

      {/* 3. WHAT CHANGES WITH SUMMIT */}
      <section className="py-20 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800" data-id="element-712">
        <div className="max-w-5xl mx-auto" data-id="element-713">
          <h2 className="text-3xl font-bold text-white mb-12 text-center" data-id="element-714">
            What Changes With Summit
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-715">
            <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl" data-id="element-716">
              <div className="w-12 h-12 rounded-full bg-slate-800 flex items-center justify-center mb-4 border border-slate-700" data-id="element-717">
                <Shield className="w-6 h-6 text-amber-400" data-id="element-718" />
              </div>
              <h3 className="text-white font-bold mb-2" data-id="element-719">Execution Ownership</h3>
              <p className="text-slate-400 text-sm" data-id="element-720">
                Recruiting execution becomes HIRE's responsibility
              </p>
            </div>
            <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl" data-id="element-721">
              <div className="w-12 h-12 rounded-full bg-slate-800 flex items-center justify-center mb-4 border border-slate-700" data-id="element-722">
                <Users className="w-6 h-6 text-amber-400" data-id="element-723" />
              </div>
              <h3 className="text-white font-bold mb-2" data-id="element-724">Managed Throughput</h3>
              <p className="text-slate-400 text-sm" data-id="element-725">
                Interview throughput is managed, not improvised
              </p>
            </div>
            <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl" data-id="element-726">
              <div className="w-12 h-12 rounded-full bg-slate-800 flex items-center justify-center mb-4 border border-slate-700" data-id="element-727">
                <Briefcase className="w-6 h-6 text-amber-400" data-id="element-728" />
              </div>
              <h3 className="text-white font-bold mb-2" data-id="element-729">Protected Time</h3>
              <p className="text-slate-400 text-sm" data-id="element-730">
                Leadership time is protected for production and growth
              </p>
            </div>
          </div>

          <div className="p-6 bg-amber-500/5 border border-amber-500/20 rounded-lg max-w-3xl mx-auto" data-id="element-731">
            <p className="text-amber-400 font-medium text-center" data-id="element-732">
              Summit does not change the recruiting system — it changes who runs
              it.
            </p>
          </div>
        </div>
      </section>

      {/* 4. OWNERSHIP MAP */}
      <section className="py-20 px-6 md:px-12 max-w-6xl mx-auto" data-id="element-733">
        <h2 className="text-3xl font-bold text-white mb-12 text-center" data-id="element-734">
          Ownership Map
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16" data-id="element-735">
          {/* HIRE Owns */}
          <div className="bg-slate-900/40 border border-amber-500/20 rounded-xl p-8 relative overflow-hidden" data-id="element-736">
            <div className="absolute top-0 left-0 w-full h-1 bg-amber-500" data-id="element-737" />
            <h3 className="text-xl font-bold text-white mb-8 flex items-center" data-id="element-738">
              <span className="w-2 h-2 rounded-full bg-amber-500 mr-3" data-id="element-739" />
              HIRE Owns
            </h3>
            <ul className="space-y-4" data-id="element-740">
              {['Dedicated recruiter capacity (operated and managed by HIRE)', 'Interview execution and scheduling', 'Candidate follow-up and throughput', 'Recruiting execution accountability'].map((item, idx) => <li key={idx} className="flex items-start text-slate-300" data-id="element-741">
                  <Check className="w-5 h-5 text-amber-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-742" />
                  <span data-id="element-743">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* You Own */}
          <div className="bg-slate-900/40 border border-slate-800 rounded-xl p-8 relative overflow-hidden" data-id="element-744">
            <div className="absolute top-0 left-0 w-full h-1 bg-slate-600" data-id="element-745" />
            <h3 className="text-xl font-bold text-white mb-8 flex items-center" data-id="element-746">
              <span className="w-2 h-2 rounded-full bg-slate-600 mr-3" data-id="element-747" />
              You Own
            </h3>
            <ul className="space-y-4" data-id="element-748">
              {['Final hiring approvals', 'Sales leadership and production', 'Culture and performance expectations'].map((item, idx) => <li key={idx} className="flex items-start text-slate-400" data-id="element-749">
                  <div className="w-5 h-5 rounded-full bg-slate-800 border border-slate-700 mr-3 mt-0.5 flex-shrink-0 flex items-center justify-center" data-id="element-750">
                    <div className="w-1.5 h-1.5 rounded-full bg-slate-500" data-id="element-751" />
                  </div>
                  <span data-id="element-752">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-8 text-center" data-id="element-753">
          <p className="text-slate-400 font-medium" data-id="element-754">
            Summit transfers execution ownership and staffing risk to HIRE.
          </p>
        </div>
      </section>

      {/* 5. RECRUITER CAPACITY */}
      <section className="py-20 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800" data-id="element-755">
        <div className="max-w-4xl mx-auto" data-id="element-756">
          <h2 className="text-3xl font-bold text-white mb-12 text-center" data-id="element-757">
            Recruiter Capacity
          </h2>

          <div className="bg-slate-900/40 border border-slate-800 rounded-xl p-8 md:p-12" data-id="element-758">
            <div className="space-y-6" data-id="element-759">
              <div className="flex items-start" data-id="element-760">
                <div className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center mr-4 flex-shrink-0 border border-slate-700" data-id="element-761">
                  <Check className="w-5 h-5 text-amber-400" data-id="element-762" />
                </div>
                <div data-id="element-763">
                  <h3 className="text-white font-bold mb-2" data-id="element-764">
                    Trained and Managed by HIRE
                  </h3>
                  <p className="text-slate-400 text-sm" data-id="element-765">
                    Recruiters are trained, managed, and quality-controlled by
                    HIRE to maintain consistency and professionalism.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-766">
                <div className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center mr-4 flex-shrink-0 border border-slate-700" data-id="element-767">
                  <Check className="w-5 h-5 text-amber-400" data-id="element-768" />
                </div>
                <div data-id="element-769">
                  <h3 className="text-white font-bold mb-2" data-id="element-770">
                    Represents Your Brand
                  </h3>
                  <p className="text-slate-400 text-sm" data-id="element-771">
                    Recruiters represent the client's brand with professionalism
                    and alignment to company values.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-772">
                <div className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center mr-4 flex-shrink-0 border border-slate-700" data-id="element-773">
                  <Check className="w-5 h-5 text-amber-400" data-id="element-774" />
                </div>
                <div data-id="element-775">
                  <h3 className="text-white font-bold mb-2" data-id="element-776">
                    Designed for Consistency
                  </h3>
                  <p className="text-slate-400 text-sm" data-id="element-777">
                    Capacity is designed to support consistent interview flow,
                    not heroic bursts.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 6. PRICING */}
      <section className="py-20 px-6 md:px-12 max-w-6xl mx-auto" data-id="element-778">
        <div className="text-center mb-12" data-id="element-779">
          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-780">
            Partnership Pricing
          </h2>
          <p className="text-slate-400" data-id="element-781">
            When recruiting execution becomes the constraint, HIRE runs it for
            you.
          </p>
        </div>

        <div className="flex justify-center mb-12" data-id="element-782">
          <div className="bg-slate-900/50 p-1 rounded-lg border border-slate-800 flex items-center" data-id="element-783">
            <button onClick={() => setIsPartialCampaign(false)} className={`px-4 py-2 rounded-md text-sm font-medium transition-all ${!isPartialCampaign ? 'bg-amber-600 text-white shadow-lg' : 'text-slate-400 hover:text-white'}`} data-id="element-784">
              Full Campaign
            </button>
            <button onClick={() => setIsPartialCampaign(true)} className={`px-4 py-2 rounded-md text-sm font-medium transition-all ${isPartialCampaign ? 'bg-amber-600 text-white shadow-lg' : 'text-slate-400 hover:text-white'}`} data-id="element-785">
              Partial Campaign
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-786">
          {/* Build Fee */}
          <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl relative overflow-hidden" data-id="element-787">
            <div className="mb-4" data-id="element-788">
              <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-789">
                Build (One-Time)
              </div>
              <div className="text-3xl font-bold text-white" data-id="element-790">$5,000</div>
              <div className="mt-4 inline-flex items-center px-3 py-1 rounded-full bg-[#7FE0C3]/10 border border-[#7FE0C3]/20 text-[#7FE0C3] text-xs font-bold" data-id="element-791">
                <Shield className="w-3 h-3 mr-1.5" data-id="element-792" />
                Money Back Guarantee
              </div>
            </div>
          </div>

          {/* Monthly Total */}
          <div className="bg-slate-900/40 border border-amber-500/30 p-6 rounded-xl relative" data-id="element-793">
            <div className="absolute top-0 left-0 w-full h-1 bg-amber-500 rounded-t-xl" data-id="element-794" />
            <div className="mb-4" data-id="element-795">
              <div className="text-xs text-amber-400 uppercase tracking-widest mb-2" data-id="element-796">
                Total Monthly
              </div>
              <div className="text-4xl font-bold text-white mb-1" data-id="element-797">
                ${isPartialCampaign ? '5,250' : '8,000'}
              </div>
              <div className="text-sm text-slate-500 mb-6" data-id="element-798">/ month</div>

              <div className="space-y-3 pt-4 border-t border-slate-800/50" data-id="element-799">
                <div className="flex justify-between text-sm" data-id="element-800">
                  <span className="text-slate-400" data-id="element-801">System Fee</span>
                  <span className="text-white font-medium" data-id="element-802">$2,500</span>
                </div>
                <div className="flex justify-between text-sm" data-id="element-803">
                  <span className="text-slate-400" data-id="element-804">
                    {isPartialCampaign ? 'Partial' : 'Full'} Campaign
                  </span>
                  <span className="text-white font-medium" data-id="element-805">
                    ${isPartialCampaign ? '2,750' : '5,500'}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Performance Bonuses */}
          <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl" data-id="element-806">
            <div className="mb-4" data-id="element-807">
              <div className="text-xs text-amber-400 uppercase tracking-widest mb-4" data-id="element-808">
                Performance Bonuses
              </div>
              <ul className="space-y-3" data-id="element-809">
                <li className="flex items-start" data-id="element-810">
                  <span className="text-amber-400 mr-3 text-xl font-bold" data-id="element-811">
                    $250
                  </span>
                  <span className="text-slate-300 text-lg" data-id="element-812">
                    per rep at launch
                  </span>
                </li>
                <li className="flex items-start" data-id="element-813">
                  <span className="text-amber-400 mr-3 text-xl font-bold" data-id="element-814">
                    $250
                  </span>
                  <span className="text-slate-300 text-lg" data-id="element-815">
                    per rep at 30 days
                  </span>
                </li>
                <li className="flex items-start" data-id="element-816">
                  <span className="text-amber-400 mr-3 text-xl font-bold" data-id="element-817">
                    $250
                  </span>
                  <span className="text-slate-300 text-lg" data-id="element-818">
                    per rep at 60 days
                  </span>
                </li>
                <li className="flex items-start" data-id="element-819">
                  <span className="text-amber-400 mr-3 text-xl font-bold" data-id="element-820">
                    $250
                  </span>
                  <span className="text-slate-300 text-lg" data-id="element-821">
                    per rep at 90 days
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-8 p-6 bg-amber-500/5 border border-amber-500/20 rounded-lg max-w-3xl mx-auto" data-id="element-822">
          <p className="text-amber-400 text-center font-medium" data-id="element-823">
            Summit pricing reflects recruiting execution ownership and recruiter
            staffing responsibility.
          </p>
        </div>
      </section>

      {/* 7. WHO SUMMIT IS FOR / NOT FOR */}
      <section className="py-20 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800" data-id="element-824">
        <div className="max-w-5xl mx-auto" data-id="element-825">
          <h2 className="text-3xl font-bold text-white mb-12 text-center" data-id="element-826">
            Who Summit Is For
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-827">
            <div data-id="element-828">
              <h3 className="text-lg font-bold text-white mb-6 flex items-center" data-id="element-829">
                <Check className="w-5 h-5 text-amber-500 mr-2" data-id="element-830" />
                Summit is a fit if you:
              </h3>
              <ul className="space-y-4" data-id="element-831">
                {['Want recruiting execution off your plate', 'Believe sales leaders should be selling, not interviewing', 'Prefer external ownership over internal hiring', 'Trust HIRE to manage recruiter performance'].map((item, idx) => <li key={idx} className="text-slate-400 flex items-start" data-id="element-832">
                    <span className="w-1.5 h-1.5 rounded-full bg-amber-500 mr-3 mt-2" data-id="element-833" />
                    {item}
                  </li>)}
              </ul>
            </div>
            <div data-id="element-834">
              <h3 className="text-lg font-bold text-white mb-6 flex items-center" data-id="element-835">
                <X className="w-5 h-5 text-slate-500 mr-2" data-id="element-836" />
                Summit is not a fit if you:
              </h3>
              <ul className="space-y-4" data-id="element-837">
                {['Want to manage recruiters internally', 'Prefer hands-on control over execution', 'Only want infrastructure or consulting'].map((item, idx) => <li key={idx} className="text-slate-400 flex items-start" data-id="element-838">
                    <span className="w-1.5 h-1.5 rounded-full bg-slate-600 mr-3 mt-2" data-id="element-839" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 8. RELATIONSHIP TO ADVANTAGE */}
      <section className="py-20 px-6 md:px-12 max-w-4xl mx-auto" data-id="element-840">
        <div className="bg-slate-900/30 border border-slate-800 rounded-xl p-8 md:p-12 text-center" data-id="element-841">
          <h2 className="text-2xl font-bold text-white mb-6" data-id="element-842">
            Progression Path
          </h2>
          <p className="text-slate-300 leading-relaxed max-w-2xl mx-auto" data-id="element-843">
            Most Summit partners start with Advantage. Summit exists when the
            system works — and execution capacity becomes the constraint.
          </p>
        </div>
      </section>

      {/* 9. CTA */}
      <section className="py-32 px-6 md:px-12 text-center border-t border-slate-800/50" data-id="element-844">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-845">
          See if Summit is the right execution model for your team.
        </h2>
        <button className="inline-flex items-center px-8 py-4 bg-amber-600 hover:bg-amber-700 text-white font-bold rounded-lg transition-all" data-id="element-846">
          Discuss Summit
          <ArrowRight className="ml-2 w-5 h-5" data-id="element-847" />
        </button>
      </section>
    </div>;
}